import { ProjectService } from "../../../types/domain";
import { DeleteProjectServiceDialog } from "./DeleteProjectServiceDialog";
import { CreateEditProjectServiceDialog } from "./CreateEditProjectServiceDialog";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { DataTable, TableColumn } from "@/components/common/Table";

type ProjectServiceListProps = {
  services: ProjectService[],
  fetchServices: () => Promise<void>,
  isLoading?: boolean
}

export const ProjectServiceList = ({ services, fetchServices, isLoading = false }: ProjectServiceListProps) => {
  const columns: TableColumn<ProjectService>[] = [
    {
      key: "name",
      header: "Service",
      skeleton: { variant: 'long' },
      render: (service: ProjectService) => (
        <CreateEditProjectServiceDialog
          services={services}
          serviceToEdit={service}
          callBack={fetchServices}
          triggerVariant={"link"}
          triggerText={
            service.id === 0
              ? `${service.name} (Default)`
              : service.name
          }
        />
      )
    },
    {
      key: "actions",
      header: "",
      isAction: true,
      skeleton: { variant: 'short' },
      render: (service: ProjectService) => (
        <>
          <CreateEditProjectServiceDialog
            services={services}
            serviceToEdit={service}
            callBack={fetchServices}
            triggerVariant={"icon"}
            triggerIcon={faPencil}
          />
          <DeleteProjectServiceDialog service={service} callBack={fetchServices} />
        </>
      )
    }
  ];

  return (
    <DataTable<ProjectService>
      columns={columns}
      data={services}
      isLoading={isLoading}
      skeletonRows={8}
    />
  );
};
